import React from 'react';
import PropTypes from 'prop-types';
import DefaultSpinner from './DefaultSpinner';

export default function Loading({ renderOnLoad }) {
    return renderOnLoad;
}

Loading.propTypes = {
    renderOnLoad: PropTypes.node,
};

Loading.defaultProps = {
    renderOnLoad: <DefaultSpinner />,
};
